export default "__VITE_ASSET__D_qP6Rhw__"